var _g, _g2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _g3, _g4, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _g5, _path25, _path26, _path27, _path28, _path29, _path30, _g6, _path31, _path32, _path33, _path34, _path35, _path36, _g7, _path37, _path38, _path39, _path40, _path41, _path42, _g8, _g9, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _g10, _path55, _path56, _path57, _path58, _path59, _path60, _g11, _path61, _path62, _path63, _path64, _path65, _path66, _g12, _g13, _path67, _path68, _path69, _path70, _path71, _path72;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDesktopSm(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 786,
    height: 358,
    viewBox: "0 0 786 358",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M234.464 167.872L179.612 199.5L50.1345 124.384L106.968 92.7559L234.464 167.872Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.221 170.006L123.484 179.958L164.226 156.319L146.344 146.367L106.221 170.006Z",
    stroke: "white",
    strokeWidth: 1.04303,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.221 222.565L123.484 232.517L164.226 208.883L146.344 198.931L106.221 222.565Z",
    stroke: "#231F20",
    strokeWidth: 1.04303,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.322 222.565L123.58 232.517L164.322 208.883L146.44 198.931L106.322 222.565Z",
    stroke: "white",
    strokeWidth: 1.04303,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.483 179.957V232.514",
    stroke: "white",
    strokeWidth: 1.04303,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.184 146.367V198.929L164.207 208.862V156.301",
    stroke: "white",
    strokeWidth: 1.04303,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.221 169.833V222.39",
    stroke: "white",
    strokeWidth: 1.04303,
    strokeMiterlimit: 10
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72.3337 146.429L89.5961 156.381L130.334 132.747L112.452 122.795L72.3337 146.429Z",
    stroke: "white",
    strokeWidth: 1.04303,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M72.334 198.992L89.5964 208.944L130.334 185.305L112.452 175.353L72.334 198.992Z",
    stroke: "#231F20",
    strokeWidth: 1.04303,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M72.4341 198.992L89.6919 208.944L130.434 185.305L112.552 175.353L72.4341 198.992Z",
    stroke: "white",
    strokeWidth: 1.04303,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M89.5962 156.383V208.944",
    stroke: "white",
    strokeWidth: 1.04303,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M112.297 122.795V175.352L130.32 185.286V132.729",
    stroke: "white",
    strokeWidth: 1.04303,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M72.334 146.256V198.817",
    stroke: "white",
    strokeWidth: 1.04303,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8918 124.049L53.1497 134.001L93.8916 110.362L76.0098 100.41L35.8918 124.049Z",
    stroke: "white",
    strokeWidth: 1.04303,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8918 176.606L53.1497 186.558L93.8916 162.924L76.0098 152.972L35.8918 176.606Z",
    stroke: "#231F20",
    strokeWidth: 1.04303,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9875 176.606L53.2499 186.558L93.9919 162.924L76.1055 152.972L35.9875 176.606Z",
    stroke: "white",
    strokeWidth: 1.04303,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1499 134.002V186.559",
    stroke: "white",
    strokeWidth: 1.04303,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M75.855 100.41V152.972L93.8735 162.905V110.349",
    stroke: "white",
    strokeWidth: 1.04303,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8918 123.877V176.434",
    stroke: "white",
    strokeWidth: 1.04303,
    strokeMiterlimit: 10
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 100.474L19.2624 110.426L60.0043 86.7919L42.1225 76.8398L2 100.474Z",
    stroke: "white",
    strokeWidth: 1.04303,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 153.037L19.2624 162.989L60.0043 139.354L42.1225 129.402L2 153.037Z",
    stroke: "#231F20",
    strokeWidth: 1.04303,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.10059 153.037L19.363 162.989L60.1004 139.354L42.2186 129.402L2.10059 153.037Z",
    stroke: "white",
    strokeWidth: 1.04303,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2622 110.427V162.988",
    stroke: "white",
    strokeWidth: 1.04303,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.9678 76.8398V129.401L59.9862 139.335V86.7737",
    stroke: "white",
    strokeWidth: 1.04303,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 100.301V152.862",
    stroke: "white",
    strokeWidth: 1.04303,
    strokeMiterlimit: 10
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M225.309 100.869L242.567 110.821L283.309 87.1864L265.427 77.2344L225.309 100.869Z",
    stroke: "white",
    strokeWidth: 1.04303,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.308 153.43L242.566 163.382L283.308 139.743L265.426 129.791L225.308 153.43Z",
    stroke: "#231F20",
    strokeWidth: 1.04303,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.404 153.43L242.666 163.382L283.408 139.743L265.527 129.791L225.404 153.43Z",
    stroke: "white",
    strokeWidth: 1.04303,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.566 110.82V163.382",
    stroke: "white",
    strokeWidth: 1.04303,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.271 77.2344V129.791L283.29 139.725V87.1682",
    stroke: "white",
    strokeWidth: 1.04303,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.308 100.695V153.257",
    stroke: "white",
    strokeWidth: 1.04303,
    strokeMiterlimit: 10
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M191.818 81.2946L209.08 91.2466L249.822 67.6122L231.94 57.6602L191.818 81.2946Z",
    stroke: "white",
    strokeWidth: 1.04303,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M191.818 133.857L209.08 143.809L249.822 120.17L231.94 110.218L191.818 133.857Z",
    stroke: "#231F20",
    strokeWidth: 1.04303,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M191.918 133.857L209.176 143.809L249.918 120.17L232.036 110.218L191.918 133.857Z",
    stroke: "white",
    strokeWidth: 1.04303,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M209.08 91.2461V143.808",
    stroke: "white",
    strokeWidth: 1.04303,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M231.781 57.6602V110.217L249.804 120.151V67.594",
    stroke: "white",
    strokeWidth: 1.04303,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M191.818 81.1211V133.683",
    stroke: "white",
    strokeWidth: 1.04303,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M155.376 58.9115L172.634 68.8635L213.376 45.2245L195.494 35.2725L155.376 58.9115Z",
    stroke: "white",
    strokeWidth: 1.04303,
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M155.376 111.468L172.634 121.42L213.376 97.786L195.494 87.834L155.376 111.468Z",
    stroke: "#231F20",
    strokeWidth: 1.04303,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M155.471 111.468L172.734 121.42L213.476 97.786L195.594 87.834L155.471 111.468Z",
    stroke: "white",
    strokeWidth: 1.04303,
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M172.634 68.8643V121.421",
    stroke: "white",
    strokeWidth: 1.04303,
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M195.339 35.2725V87.8339L213.358 97.7678V45.2109",
    stroke: "white",
    strokeWidth: 1.04303,
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M155.376 58.7393V111.296",
    stroke: "white",
    strokeWidth: 1.04303,
    strokeMiterlimit: 10
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M121.885 39.7311L139.147 49.6832L179.889 26.0487L162.007 16.0967L121.885 39.7311Z",
    stroke: "white",
    strokeWidth: 1.04303,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.885 92.2926L139.147 102.245L179.889 78.6103L162.007 68.6582L121.885 92.2926Z",
    stroke: "#231F20",
    strokeWidth: 1.04303,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.985 92.2926L139.247 102.245L179.985 78.6103L162.103 68.6582L121.985 92.2926Z",
    stroke: "white",
    strokeWidth: 1.04303,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.147 49.6836V102.245",
    stroke: "white",
    strokeWidth: 1.04303,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.852 16.0967V68.6581L179.871 78.592V26.0305",
    stroke: "white",
    strokeWidth: 1.04303,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.885 39.5645V92.1214",
    stroke: "white",
    strokeWidth: 1.04303,
    strokeMiterlimit: 10
  }))), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M389.635 165.535L372.373 175.487L331.631 151.848L349.512 141.896L389.635 165.535Z",
    stroke: "white",
    strokeWidth: 1.04303,
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M389.635 218.092L372.373 228.045L331.631 204.41L349.512 194.458L389.635 218.092Z",
    stroke: "#231F20",
    strokeWidth: 1.04303,
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M389.535 218.092L372.277 228.045L331.535 204.41L349.417 194.458L389.535 218.092Z",
    stroke: "white",
    strokeWidth: 1.04303,
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M372.373 175.487V228.044",
    stroke: "white",
    strokeWidth: 1.04303,
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M349.672 141.896V194.457L331.649 204.391V151.834",
    stroke: "white",
    strokeWidth: 1.04303,
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M389.635 165.362V217.919",
    stroke: "white",
    strokeWidth: 1.04303,
    strokeMiterlimit: 10
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M534.502 291.896L479.649 323.524L350.172 248.407L407.006 216.779L534.502 291.896Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M355.274 184.957L338.016 194.909L297.274 171.27L315.156 161.318L355.274 184.957Z",
    stroke: "white",
    strokeWidth: 1.04303,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.274 237.515L338.016 247.467L297.274 223.833L315.156 213.881L355.274 237.515Z",
    stroke: "#231F20",
    strokeWidth: 1.04303,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.178 237.515L337.916 247.467L297.174 223.833L315.056 213.881L355.178 237.515Z",
    stroke: "white",
    strokeWidth: 1.04303,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.016 194.909V247.466",
    stroke: "white",
    strokeWidth: 1.04303,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.311 161.318V213.88L297.292 223.814V171.252",
    stroke: "white",
    strokeWidth: 1.04303,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.274 184.784V237.341",
    stroke: "white",
    strokeWidth: 1.04303,
    strokeMiterlimit: 10
  }))), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M499.685 191.816L482.423 201.768L441.681 178.129L459.568 168.177L499.685 191.816Z",
    stroke: "white",
    strokeWidth: 1.04303,
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M499.685 244.374L482.423 254.326L441.681 230.691L459.568 220.739L499.685 244.374Z",
    stroke: "#231F20",
    strokeWidth: 1.04303,
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M499.585 244.374L482.328 254.326L441.586 230.691L459.468 220.739L499.585 244.374Z",
    stroke: "white",
    strokeWidth: 1.04303,
    strokeMiterlimit: 10
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M482.423 201.769V254.325",
    stroke: "white",
    strokeWidth: 1.04303,
    strokeMiterlimit: 10
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M459.723 168.177V220.738L441.7 230.672V178.111",
    stroke: "white",
    strokeWidth: 1.04303,
    strokeMiterlimit: 10
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M499.686 191.644V244.2",
    stroke: "white",
    strokeWidth: 1.04303,
    strokeMiterlimit: 10
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M553.172 221.467L535.909 231.42L495.167 207.785L513.054 197.833L553.172 221.467Z",
    stroke: "white",
    strokeWidth: 1.04303,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553.172 274.03L535.909 283.982L495.167 260.343L513.054 250.391L553.172 274.03Z",
    stroke: "#231F20",
    strokeWidth: 1.04303,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553.072 274.03L535.814 283.982L495.072 260.343L512.954 250.391L553.072 274.03Z",
    stroke: "white",
    strokeWidth: 1.04303,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.909 231.42V283.981",
    stroke: "white",
    strokeWidth: 1.04303,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.209 197.833V250.39L495.186 260.324V207.767",
    stroke: "white",
    strokeWidth: 1.04303,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553.172 221.295V273.856",
    stroke: "white",
    strokeWidth: 1.04303,
    strokeMiterlimit: 10
  }))), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M403.668 156.266L420.93 166.218L461.668 142.584L443.786 132.632L403.668 156.266Z",
    stroke: "white",
    strokeWidth: 1.04303,
    strokeMiterlimit: 10
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M403.668 208.827L420.93 218.78L461.668 195.141L443.786 185.188L403.668 208.827Z",
    stroke: "#231F20",
    strokeWidth: 1.04303,
    strokeMiterlimit: 10
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M403.764 208.827L421.026 218.78L461.768 195.141L443.886 185.188L403.764 208.827Z",
    stroke: "white",
    strokeWidth: 1.04303,
    strokeMiterlimit: 10
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M420.93 166.218V218.779",
    stroke: "white",
    strokeWidth: 1.04303,
    strokeMiterlimit: 10
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M443.631 132.632V185.189L461.654 195.123V142.566",
    stroke: "white",
    strokeWidth: 1.04303,
    strokeMiterlimit: 10
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M403.668 156.093V208.654",
    stroke: "white",
    strokeWidth: 1.04303,
    strokeMiterlimit: 10
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M365.681 132.586L382.944 142.538L423.685 118.899L405.799 108.947L365.681 132.586Z",
    stroke: "white",
    strokeWidth: 1.04303,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.681 185.144L382.944 195.096L423.685 171.462L405.799 161.51L365.681 185.144Z",
    stroke: "#231F20",
    strokeWidth: 1.04303,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.781 185.144L383.039 195.096L423.781 171.462L405.899 161.51L365.781 185.144Z",
    stroke: "white",
    strokeWidth: 1.04303,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.645 108.947V161.509L423.668 171.443V118.886",
    stroke: "white",
    strokeWidth: 1.04303,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.681 184.971V132.414L382.944 142.539V195.096",
    stroke: "white",
    strokeWidth: 1.04303,
    strokeMiterlimit: 10
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M406.259 294.024L423.521 303.976L464.263 280.342L446.382 270.39L406.259 294.024Z",
    stroke: "white",
    strokeWidth: 1.04303,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.259 346.585L423.521 356.537L464.263 332.898L446.382 322.946L406.259 346.585Z",
    stroke: "#231F20",
    strokeWidth: 1.04303,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.359 346.585L423.617 356.537L464.359 332.898L446.477 322.946L406.359 346.585Z",
    stroke: "white",
    strokeWidth: 1.04303,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.521 303.976V356.537",
    stroke: "white",
    strokeWidth: 1.04303,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.222 270.39V322.947L464.245 332.88V280.323",
    stroke: "white",
    strokeWidth: 1.04303,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.259 293.851V346.412",
    stroke: "white",
    strokeWidth: 1.04303,
    strokeMiterlimit: 10
  }))), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M372.372 270.452L389.634 280.405L430.376 256.766L412.49 246.813L372.372 270.452Z",
    stroke: "white",
    strokeWidth: 1.04303,
    strokeMiterlimit: 10
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M372.372 323.01L389.634 332.962L430.376 309.328L412.49 299.376L372.372 323.01Z",
    stroke: "#231F20",
    strokeWidth: 1.04303,
    strokeMiterlimit: 10
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M372.472 323.01L389.73 332.962L430.471 309.328L412.59 299.376L372.472 323.01Z",
    stroke: "white",
    strokeWidth: 1.04303,
    strokeMiterlimit: 10
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M389.634 280.405V332.962",
    stroke: "white",
    strokeWidth: 1.04303,
    strokeMiterlimit: 10
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M412.334 246.813V299.375L430.358 309.309V256.752",
    stroke: "white",
    strokeWidth: 1.04303,
    strokeMiterlimit: 10
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M372.372 270.28V322.837",
    stroke: "white",
    strokeWidth: 1.04303,
    strokeMiterlimit: 10
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M784 138.894L766.742 148.846L726 125.212L743.882 115.26L784 138.894Z",
    stroke: "white",
    strokeWidth: 1.04303,
    strokeMiterlimit: 10
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M784 191.456L766.742 201.408L726 177.769L743.882 167.817L784 191.456Z",
    stroke: "#231F20",
    strokeWidth: 1.04303,
    strokeMiterlimit: 10
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M783.904 191.456L766.642 201.408L725.9 177.769L743.786 167.817L783.904 191.456Z",
    stroke: "white",
    strokeWidth: 1.04303,
    strokeMiterlimit: 10
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M766.742 148.848V201.409",
    stroke: "white",
    strokeWidth: 1.04303,
    strokeMiterlimit: 10
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M744.037 115.26V167.817L726.019 177.75V125.194",
    stroke: "white",
    strokeWidth: 1.04303,
    strokeMiterlimit: 10
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M784 138.72V191.281",
    stroke: "white",
    strokeWidth: 1.04303,
    strokeMiterlimit: 10
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M738.216 160.265L683.364 191.893L553.886 116.776L610.72 85.1484L738.216 160.265Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M754.868 159.359L737.606 169.311L696.864 145.677L714.746 135.725L754.868 159.359Z",
    stroke: "white",
    strokeWidth: 1.04303,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M754.768 211.919L737.51 221.871L696.768 198.232L714.65 188.28L754.768 211.919Z",
    stroke: "white",
    strokeWidth: 1.04303,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M737.605 169.311V221.872",
    stroke: "white",
    strokeWidth: 1.04303,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M714.905 135.725V188.282L696.882 198.215V145.658",
    stroke: "white",
    strokeWidth: 1.04303,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M754.868 159.186V211.747",
    stroke: "white",
    strokeWidth: 1.04303,
    strokeMiterlimit: 10
  }))), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M703.4 60.1839L686.137 70.136L645.396 46.497L663.282 36.5449L703.4 60.1839Z",
    stroke: "white",
    strokeWidth: 1.04303,
    strokeMiterlimit: 10
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M703.4 112.74L686.138 122.692L645.396 99.0575L663.282 89.1055L703.4 112.74Z",
    stroke: "#231F20",
    strokeWidth: 1.04303,
    strokeMiterlimit: 10
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M703.3 112.74L686.042 122.692L645.3 99.0575L663.182 89.1055L703.3 112.74Z",
    stroke: "white",
    strokeWidth: 1.04303,
    strokeMiterlimit: 10
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M686.137 70.1357V122.693",
    stroke: "white",
    strokeWidth: 1.04303,
    strokeMiterlimit: 10
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M663.437 36.5449V89.1064L645.414 99.0402V46.4833",
    stroke: "white",
    strokeWidth: 1.04303,
    strokeMiterlimit: 10
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M703.4 60.0117V112.569",
    stroke: "white",
    strokeWidth: 1.04303,
    strokeMiterlimit: 10
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M756.886 89.8356L739.624 99.7877L698.882 76.1532L716.763 66.2012L756.886 89.8356Z",
    stroke: "white",
    strokeWidth: 1.04303,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M756.886 142.398L739.624 152.35L698.882 128.711L716.763 118.759L756.886 142.398Z",
    stroke: "#231F20",
    strokeWidth: 1.04303,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M756.786 142.398L739.528 152.35L698.786 128.711L716.668 118.759L756.786 142.398Z",
    stroke: "white",
    strokeWidth: 1.04303,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M739.623 99.7881V152.35",
    stroke: "white",
    strokeWidth: 1.04303,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M716.923 66.2012V118.758L698.9 128.696V76.135",
    stroke: "white",
    strokeWidth: 1.04303,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M756.886 89.6611V142.223",
    stroke: "white",
    strokeWidth: 1.04303,
    strokeMiterlimit: 10
  }))), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M607.382 24.6344L624.64 34.5865L665.382 10.9521L647.5 1L607.382 24.6344Z",
    stroke: "white",
    strokeWidth: 1.04303,
    strokeMiterlimit: 10
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M607.382 77.1966L624.64 87.1487L665.382 63.5097L647.5 53.5576L607.382 77.1966Z",
    stroke: "#231F20",
    strokeWidth: 1.04303,
    strokeMiterlimit: 10
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M607.477 77.1966L624.74 87.1487L665.482 63.5097L647.6 53.5576L607.477 77.1966Z",
    stroke: "white",
    strokeWidth: 1.04303,
    strokeMiterlimit: 10
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M624.64 34.5879V87.1494",
    stroke: "white",
    strokeWidth: 1.04303,
    strokeMiterlimit: 10
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M647.345 1V53.5569L665.363 63.4953V10.9338",
    stroke: "white",
    strokeWidth: 1.04303,
    strokeMiterlimit: 10
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M607.382 24.4609V77.0224",
    stroke: "white",
    strokeWidth: 1.04303,
    strokeMiterlimit: 10
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M541.711 117.96L558.969 127.912L599.711 104.273L581.829 94.3213L541.711 117.96Z",
    stroke: "white",
    strokeWidth: 1.04303,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.712 170.519L558.97 180.471L599.711 156.837L581.83 146.885L541.712 170.519Z",
    stroke: "#231F20",
    strokeWidth: 1.04303,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.807 170.519L559.07 180.471L599.812 156.837L581.93 146.885L541.807 170.519Z",
    stroke: "white",
    strokeWidth: 1.04303,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M581.675 94.3213V146.883L599.698 156.817V104.26",
    stroke: "white",
    strokeWidth: 1.04303,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.712 170.344V117.787L558.97 127.912V180.469",
    stroke: "white",
    strokeWidth: 1.04303,
    strokeMiterlimit: 10
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M609.973 162.392L627.236 172.344L667.978 148.71L650.091 138.758L609.973 162.392Z",
    stroke: "white",
    strokeWidth: 1.04303,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.973 214.954L627.236 224.906L667.978 201.267L650.091 191.315L609.973 214.954Z",
    stroke: "#231F20",
    strokeWidth: 1.04303,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.073 214.954L627.331 224.906L668.073 201.267L650.191 191.315L610.073 214.954Z",
    stroke: "white",
    strokeWidth: 1.04303,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627.236 172.345V224.906",
    stroke: "white",
    strokeWidth: 1.04303,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649.937 138.758V191.315L667.96 201.253V148.692",
    stroke: "white",
    strokeWidth: 1.04303,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.973 162.219V214.78",
    stroke: "white",
    strokeWidth: 1.04303,
    strokeMiterlimit: 10
  }))), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M576.086 138.822L593.349 148.774L634.086 125.14L616.204 115.188L576.086 138.822Z",
    stroke: "white",
    strokeWidth: 1.04303,
    strokeMiterlimit: 10
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M576.086 191.379L593.349 201.331L634.086 177.696L616.204 167.744L576.086 191.379Z",
    stroke: "#231F20",
    strokeWidth: 1.04303,
    strokeMiterlimit: 10
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M576.187 191.379L593.445 201.331L634.187 177.696L616.305 167.744L576.187 191.379Z",
    stroke: "white",
    strokeWidth: 1.04303,
    strokeMiterlimit: 10
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M593.349 148.773V201.33",
    stroke: "white",
    strokeWidth: 1.04303,
    strokeMiterlimit: 10
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M616.05 115.188V167.744L634.073 177.678V125.121",
    stroke: "white",
    strokeWidth: 1.04303,
    strokeMiterlimit: 10
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M576.086 138.648V191.205",
    stroke: "white",
    strokeWidth: 1.04303,
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktopSm);
export default __webpack_public_path__ + "static/media/desktop-sm.cfd1a719d525feb09b71b9db94e6940a.svg";
export { ForwardRef as ReactComponent };